import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  bitpayLogo: {
    width: 120,
  },
}));

export default useStyles;
